import gql from "graphql-tag";

export default gql`
	query Writebacks(
		$cursor: ID!
		$type: String
		$startDate: String
		$endDate: String
		$limit: Int
		$order: String
		$orderBy: String
		$company: String
		$school: String
		$status: String
	) {
		Writebacks(
			cursor: $cursor
			type: $type
			startDate: $startDate
			endDate: $endDate
			limit: $limit
			order: $order
			orderBy: $orderBy
			company: $company
			school: $school
			status: $status
		) {
			data {
				id
				type
				created_at
				run_at
				status
				payload
				School {
					id
					name
				}
				Company {
					id
					name
				}
			}
			paginator {
				current_page
				first_page_url
				next_page_url
				per_page
				prev_page_url
				to
			}
		}
	}
`;
